var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectGame")
                  },
                  on: { change: _vm.gamechangeManage },
                  model: {
                    value: _vm.searchData.game,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "game", $$v)
                    },
                    expression: "searchData.game"
                  }
                },
                _vm._l(_vm.searchgames, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.game_name, value: item.game_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectPlatform")
                  },
                  on: { change: _vm.platformchangeManage },
                  model: {
                    value: _vm.searchData.platform,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platform", $$v)
                    },
                    expression: "searchData.platform"
                  }
                },
                _vm._l(_vm.searchplatforms, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.platform_name,
                      value: item.platform_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectChannel")
                  },
                  on: { change: _vm.channelchangeManage },
                  model: {
                    value: _vm.searchData.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "channel", $$v)
                    },
                    expression: "searchData.channel"
                  }
                },
                _vm._l(_vm.searchchannels, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.channel_name,
                      value: item.channel_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectDeliveryPackage")
                  },
                  model: {
                    value: _vm.searchData.pkg,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "pkg", $$v)
                    },
                    expression: "searchData.pkg"
                  }
                },
                _vm._l(_vm.searchpkgs, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.pkg_name, value: item.pkg_mark }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.gameshow,
                expression: "gameshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("productLabel")))
              ])
            ]),
            _c(
              "el-table",
              {
                staticClass: "table_box",
                staticStyle: { width: "100%" },
                attrs: { "highlight-current-row": "", data: _vm.productList },
                on: {
                  "row-click": function($event) {
                    return _vm.platformclick($event, false)
                  }
                }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "name", label: _vm.$t("productNameLabel") }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.plshow,
                expression: "plshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("adPlatform")))
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pkgshow == false,
                      expression: "pkgshow == false"
                    }
                  ]
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: { click: _vm.addplatId }
                    },
                    [_vm._v(_vm._s(_vm.$t("setRelation")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticClass: "table_box",
                staticStyle: { width: "100%" },
                attrs: { "highlight-current-row": "", data: _vm.adv_platform },
                on: {
                  "row-click": function($event) {
                    return _vm.advplatformClick($event, false)
                  },
                  "selection-change": _vm.selectionChange,
                  toggleRowSelection: _vm.handleSelectionChange
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    label: _vm.$t("relation"),
                    width: "55"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "adv_platform_name",
                    label: _vm.$t("adPlatformName")
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "adv_platform_mark",
                    label: _vm.$t("adPlatformMark")
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pkgshow,
                expression: "pkgshow"
              }
            ],
            staticClass: "item_box"
          },
          [
            _c("div", { staticClass: "box_header" }, [
              _c("div", { staticClass: "titles" }, [
                _vm._v(_vm._s(_vm.$t("adPlacement")))
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: { click: _vm.addplatId }
                    },
                    [_vm._v(_vm._s(_vm.$t("setRelation")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                ref: "multipleTable2",
                staticClass: "table_box",
                staticStyle: { width: "100%" },
                attrs: {
                  border: false,
                  "highlight-current-row": "",
                  data: _vm.adv_place
                },
                on: { "selection-change": _vm.selectionChange2 }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    label: _vm.$t("relation"),
                    width: "55"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "adv_place_name",
                    label: _vm.$t("adPlacementName")
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "adv_place_mark",
                    label: _vm.$t("adPlacementMark")
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }